import { useEffect } from "react";

export const useDocTitle = (title: string | undefined): void => {
  useEffect(() => {
    document.title = title ? `${title} - Pinelist` : "Pinelist";
  }, [title]);
};
